var _g, _g2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgMagnifyingGlassSad = ({
  title,
  titleId,
  ...props
}, ref) => /*#__PURE__*/React.createElement("svg", _extends({
  width: "446.25px",
  height: "446.25px",
  enableBackground: "new 0 0 446.25 446.25",
  viewBox: "0 0 446.25 446.25",
  xmlSpace: "preserve",
  xmlns: "http://www.w3.org/2000/svg",
  ref: ref,
  "aria-labelledby": titleId
}, props), title ? /*#__PURE__*/React.createElement("title", {
  id: titleId
}, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
  id: "search"
}, /*#__PURE__*/React.createElement("path", {
  d: "M318.75,280.5h-20.4l-7.649-7.65c25.5-28.05,40.8-66.3,40.8-107.1C331.5,73.95,257.55,0,165.75,0S0,73.95,0,165.75    S73.95,331.5,165.75,331.5c40.8,0,79.05-15.3,107.1-40.8l7.65,7.649v20.4L408,446.25L446.25,408L318.75,280.5z M165.75,280.5    C102,280.5,51,229.5,51,165.75S102,51,165.75,51S280.5,102,280.5,165.75S229.5,280.5,165.75,280.5z"
}))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
  transform: "matrix(.54131 0 0 .54131 34.134 28.607)"
}, /*#__PURE__*/React.createElement("path", {
  d: "m133.9 191.3c0-10.5 8.6-19.1 19.1-19.1s19.1 8.6 19.1 19.1-8.6 19.1-19.1 19.1-19.1-8.6-19.1-19.1zm344.3 47.8c0 132-107.1 239.1-239.1 239.1s-239.1-107.1-239.1-239.1 107.1-239.1 239.1-239.1c131.9 0 239.1 107.1 239.1 239.1zm-19.2 0c0-122.4-97.5-219.9-219.9-219.9s-219.9 97.5-219.9 219.9 97.5 219.9 219.9 219.9 219.9-97.5 219.9-219.9zm-133.9-28.7c10.5 0 19.101-8.6 19.101-19.1s-8.601-19.1-19.101-19.1-19.1 8.6-19.1 19.1 8.6 19.1 19.1 19.1zm-191.2 133.9v19.1s38.2-38.2 105.2-38.2 105.2 38.2 105.2 38.2v-19.1s-38.2-38.2-105.2-38.2-105.2 38.2-105.2 38.2z"
}))));
const ForwardRef = /*#__PURE__*/forwardRef(SvgMagnifyingGlassSad);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/magnifyingGlassSad.c1e9409fda644bc4962853d256c02809.svg";